import { TermScheduleFlags } from '../../course_scheduler/services/term_schedule_flags';
import { LoadSectionRegistrationAttributesCommand } from '../../../registration_attributes/commands/load_section_registration_attributes_command';
import { RegistrationSection } from '../../course_scheduler/builders/registration_section_builder';
import { ScheduledSectionServant } from '../../course_scheduler/servants/scheduled_section_servant';
import { IWaitlistStatusDatasource } from '../../course_scheduler/datasources/waitlist_status_datasource';
import { ISectionAvailabilityDatasource } from '../../sections/datasources/section_availability_datasource';
import { ITermCoursesDatasource } from '../../term_courses/datasources/term_courses_datasource';
import { ISectionsDatasource } from '../../sections/datasources/sections_datasource';
import { IDefineCommand, ICommand, IQuery, IQueryMediator } from 'core-ts-types';
import { ScheduledSectionStatus } from '../../course_scheduler/types/scheduled_section_status_enum';
import { IRegisterSectionsDatasource } from '../../course_scheduler/datasources/register_sections_datasource';
import * as _4 from 'lodash4';
import { UpdateSectionSelectionCommand } from '../../../components/section_selections/commands/update_section_selection_command';
import { RemoveSectionSelectionCommand } from '../../../components/section_selections/commands/remove_section_selection_command';

angular
  .module('capability-ng-scheduler')
  .factory(
    'scheduleSectionCommand',
    (
      $http: ng.IHttpService,
      defineCommandORM: IDefineCommand,
      QueryMediator: IQueryMediator,
      ngSectionsDatasource: ISectionsDatasource,
      ngSectionAvailabilityDatasource: ISectionAvailabilityDatasource,
      ngWaitlistStatusDatasource: IWaitlistStatusDatasource,
      ngTermCoursesDatasource: ITermCoursesDatasource,
      ngRegisterSectionsDatasource: IRegisterSectionsDatasource,
      ngTermScheduleFlags: TermScheduleFlags,
      loadSectionRegistrationAttributesCommand: LoadSectionRegistrationAttributesCommand,
      updateSectionSelectionsCommand: UpdateSectionSelectionCommand,
      removeSectionSelectionCommand: RemoveSectionSelectionCommand,
      $q: ng.IQService
    ): ICommand => {
      return defineCommandORM('scheduleSectionCommand', (deferred, termId: number, sectionId: number) => {
        const sectionToSchedule = ngSectionsDatasource.get(sectionId);
        if (sectionToSchedule) {
          sectionToSchedule.status = ScheduledSectionStatus.PENDING;
          ngSectionsDatasource.put(sectionToSchedule);
          QueryMediator.runQueries(ngTermCoursesDatasource);
        }
        $http({
          method: 'PUT',
          url: `reg/course_schedule/term/${termId}/section/${sectionId}/`
        })
          .then(({ data }: ng.IHttpPromiseCallbackArg<any>) => {
            // Update section with status set to  "SECTION_PICKED" and update in sections datasource.
            const sectionToScheduleAvailability = ngSectionAvailabilityDatasource.get(sectionId);
            if (sectionToScheduleAvailability) {
              const {
                id,
                is_seat_available,
                is_waitlist_allowed,
                is_waitlist_full,
                is_auto_waitlist,
                avail_seats,
                last_refresh_ts,
                linked_section_coreqs_satisfied,
                has_linked_section_coreqs
              } = sectionToScheduleAvailability;
              ngWaitlistStatusDatasource.put({
                id,
                is_seat_available,
                is_waitlist_allowed,
                is_waitlist_full,
                is_auto_waitlist,
                avail_seats,
                last_refresh_ts,
                linked_section_coreqs_satisfied,
                has_linked_section_coreqs
              });
            }

            if (sectionToSchedule) {
              sectionToSchedule.status = ScheduledSectionStatus.SECTION_PICKED;
              ngSectionsDatasource.put(sectionToSchedule);
            }

            loadSectionRegistrationAttributesCommand(sectionId).then(() => {
              if (sectionToSchedule) {
                const regSection = ngSectionsDatasource.metasource().compose(sectionToSchedule);
                const isSelected = ScheduledSectionServant.canBeSelected(regSection, ngTermScheduleFlags);
                regSection.is_selected = isSelected;
                ngRegisterSectionsDatasource.put(regSection as RegistrationSection);
                updateSectionSelectionsCommand(regSection.id, isSelected);
              }
              QueryMediator.runQueries(ngTermCoursesDatasource);
              deferred.resolve();
            });
          })
          .catch(({ data }: ng.IHttpPromiseCallbackArg<any>) => {
            if (sectionToSchedule) {
              sectionToSchedule.status = ScheduledSectionStatus.UNSCHEDULED;
              ngSectionsDatasource.put(sectionToSchedule);
              ngRegisterSectionsDatasource.del(sectionToSchedule.id);
              removeSectionSelectionCommand(sectionToSchedule.id);
            }
            QueryMediator.runQueries(ngTermCoursesDatasource);
            deferred.reject(data);
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/unscheduled_sections/commands/schedule_section_command.ts